module.exports = __webpack_public_path__ + "static/media/home.a23b9d4c.svg";